exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".taskManageList .task-progress-btn {\n  vertical-align: top;\n}\n.taskManageList .task-status i {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n.taskManageList .task-status .gray {\n  background: #b6bec4;\n}\n.taskManageList .task-status .blue {\n  background: #40aefc;\n}\n.taskManageList .task-status .yellow {\n  background: #FFC12D;\n}\n.taskManageList .task-status .red {\n  background: #f63c3c;\n}\n.taskManageList .task-status .green {\n  background: #34cb82;\n}\n", ""]);

// exports
